<template>
  <multi-band-list
    key="infiniteScrollMultiBandList"
    :multi-section-list="multiSectionList"
  >
  </multi-band-list>
</template>
<script>
import MultiBandList from '@/components/section/template/cell/MultiBandList'
import { infiniteScroll } from '@/common/directives'
let debounce, oldScroll

export default {
  name: 'InfiniteScrollMultiBandList',
  components: {
    MultiBandList
  },
  props: {
    multiSectionList: {
      type: Array
    },
    loading: {
      type: Boolean
    }
  },
  directives: {
    infiniteScroll
  },
  methods: {
    callLoadMore () {
      this.$emit('load-more-editorpick')
    },
    scrollEvent (e) {
      const headerHeight = 450
      const scrollHeight = document.documentElement.scrollHeight
      const scrollTop = document.documentElement.scrollTop
      if (oldScroll < scrollTop) {
        if ((scrollHeight - (scrollTop + headerHeight)) < 700) {
          clearTimeout(debounce)
          debounce = setTimeout(() => {
            this.callLoadMore()
          }, 300)
        }
      }
      oldScroll = scrollTop
    }
  },
  mounted () {
    const searchEl = document.querySelector('.search-inner-wrapper')
    if (searchEl) {
      document.addEventListener('scroll', this.scrollEvent)
    }
  },
  beforeDestroy () {
    const searchEl = document.querySelector('.search-inner-wrapper')
    if (searchEl) {
      document.removeEventListener('scroll', this.scrollEvent)
    }
  }
}
</script>
